// Helpers for the backend's HTTP 409 { code: 'SLOT_QUOTA_EXCEEDED', activeCount, enabledSlots } response.
export const isSlotQuotaError = (error) =>
  error?.response?.status === 409 && error?.response?.data?.code === 'SLOT_QUOTA_EXCEEDED';

// Returns a user-facing notice, or null when the error is not a slot-quota error.
export const getSlotQuotaMessage = (error) => {
  if (!isSlotQuotaError(error)) return null;
  const { activeCount, enabledSlots } = error.response.data;
  const hasCounts = Number.isFinite(activeCount) && Number.isFinite(enabledSlots);
  const usage = hasCounts ? ` (${activeCount} de ${enabledSlots} slots en uso)` : '';
  return `El cliente alcanzó su límite de cámaras activas${usage}. Pasá cámaras a Terminado o Suspendida, o aumentá los slots habilitados del cliente antes de crear o activar una nueva.`;
};

// Shows the slot-quota notice with the given toast API. Returns true when handled, false otherwise.
export const notifySlotQuotaError = (error, toast) => {
  const message = getSlotQuotaMessage(error);
  if (!message) return false;
  toast.error(message, { autoClose: 8000 });
  return true;
};
